import { render } from "./Message.vue?vue&type=template&id=a9e83d1a&scoped=true&ts=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=a9e83d1a&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9e83d1a"]])

export default __exports__